import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
// eslint-disable-next-line @nrwl/nx/enforce-module-boundaries
import { BaseCRUDApiClient } from '@ideapa/app-base-api-client';
import { UtentePartecipataDto } from '@ideapa/common-dto';

import { ApiClientConfig } from '../api-client-config';

@Injectable()
export class UtentePartecipataApiClient extends BaseCRUDApiClient<UtentePartecipataDto> {
  baseUrl = this.config.apiEndpoint + '/utente-partecipata';

  constructor(http: HttpClient, private config: ApiClientConfig) {
    super(http);
  }
}
